import jaLocale from 'element-ui/lib/locale/lang/ja'//element言語パックの導入
const ja = {
    Login: {
        ToLogin: 'ログイン',
        PhoneLogin: '携帯番号登録',
        EmailLogin: 'メールボックスログイン',
        PhonePlaceholder: '携帯番号を入力してください',
        EmailPlaceholder: 'Enter email',
        Code: '認証コード',
        and: 'と',
        BeforeText: 'アカウントを作成することで、同意して遵守することができます。',
        UserAgreement: 'ユーザプロトコル',
        privacy: 'プライバシーポリシー',
        errorMessage: '認証コードエラー',
        readTitle: '次のプロトコルを読んで同意する',
        readBefore: '個人情報の安全を保証するために、まず読んで同意してください',
        cancel: 'キャンセル',
        agree: '同意して続行する',
        error1: '有効なメールアドレスを入力してください',
        error2: '正しい携帯番号を入力してください',
        error3: '認証コードを入力してください',
        success: 'ログイン成功'
    },
    ...jaLocale//ここでelement言語パックを導入する目的は、言語を切り替える際に、elementのコンポーネント内の文字が切り替えに従うことができるようにすることです
}
//エクスポート
export default ja;
